import moment from "moment";

const commonFields = {
  EndToEndUId: "",
  DMSId: "",
  AAAMTermsConditions: "no",
  CustomerMobileNo: "",
  SAPContractID: "",
  DomainContextRoot: "",
  GeographicArea: "",
  GDPR: "no",
  DeploymentRegion: "",
  DeploymentPhase: "",
  BenefitsExpected: "",
  Environment: "",
  Tier: "",
  TentativeServiceEndDate: moment()
    .add(1, "days")
    .format("YYYY-MM-DD"),
  DailyDataVolume: "",
  ConcurrentUsers: "",
  CustomerEnterpriseID: "",
  WBSEcode: "",
  ClientName: "",
  //ClientNameInternal: "",
  RITM: "",
  OpportunityID: "",
  InstanceType: "Dedicated",
  OpenAI: "False",
  ProjectName: "",
  TeamName: "",
  TeamNameOthers: "",
  DataClassification: "",
  DataClassification: "",
  Company: "",
  AvanadeCountry: "",
  AccentureCountry: "",
  Pocdetails: "",
  SecondaryPOC: "",
  ContractAvailabilityDate: moment()
    .add(1, "days")
    .format("YYYY-MM-DD"),
  // IsContractIdAvailable: "yes",   
  // adding camportalenvironment
  CAMPortalEnvironment: process.env.REACT_APP_CAMENVPORTAL,
  UsageType: ""
};
const commonAppModel = {
  DeployRegion: "",
  VendorName: "CAM",
  AaamPlatformType: "",
  AdminDistributionGroup: "",
  Users: "",
  ServiceGroup: "",
  UsersDistributionGroup: "",
  RequestNotes: "",
};

const bundleOrderModel = {
  appProductUId: [],
  DevOpsAddonsGroup: "",
  TicketFeed: "",
  ServiceNowUrl: "",
  ServiceNowUserName: "",
  ServiceNowPassword: "",
  TicketMonthlyVolume: "",
};

export const TAFormModel = {
  ...commonFields,
  ...commonAppModel,
  E2EProjectId: "",
  TicketFeed: "",
  ServiceNowUrl: "",
  ServiceNowUserName: "",
  ServiceNowPassword: "",
  TicketMonthlyVolume: "",
  TAapps: "",

};

export const DOAFormModel = {
  ...commonFields,
  ...commonAppModel,
  DevOpsAddonsGroup: "",
};

export const SPFormModel = {
  ...commonFields,
  ...commonAppModel,
};

// export const REFormModel = {
//   ...commonFields,
//   ...commonAppModel,
// };

const commonPlatformModel = {
  DeployRegion: "",
  VendorName: "CAM",
  DomainContextRoot: "",
  GDPR: "no",
  DeploymentRegion: "",
  GeographicArea: "",
  AdminDistributionGroup: "",
  Users: "",
  ServiceGroup: "",
  UsersDistributionGroup: "",
  BenefitsExpected: "",
  Environment: "",
  TentativeServiceEndDate: moment()
    .add(1, "days")
    .format("YYYY-MM-DD"),
  DailyDataVolume: "",
  ConcurrentUsers: "",
  RequestNotes: "",
  SecondaryPOC: "",
  InstanceType: "Dedicated",
};

export const ATRFormModel = {
  ...commonFields,
  ...commonPlatformModel,
  // ConfigurationType: "full",
  AaamPlatformType: "myWizard AiOps Automatic Ticket Resolver Platform",
  Tier: "",
  ProductInstanceUrl: null,
  CloudPlatform: "",
  MyClient: "",
  BaseOS: "",
  RDSMultiAZ: false,
  IsMultiZoneDeployment: false,
  DialogFlow: "disabled",
  DialogFlowClientToken: "",
  DialogFlowDevToken: "",
  ChatGPT: "aiops-deployment",
  EnableQuasar: "False",
  OpenAiRegion: "",
  OpenAITextEmbeddingsModel: "sentence-transformers/all-mpnet-base-v2",
  SuperAdminDistributionGroup: "",
  ATRVersion: "4.9.2"
};

export const EventOpsFormModel = {
  ...commonFields,
  ...commonPlatformModel,
  // ConfigurationType: "full",
  AaamPlatformType: "myWizard AiOps EventOps Platform",
  Tier: "",
  ProductInstanceUrl: null,
  CloudPlatform: "",
  MyClient: "",
  BaseOS: "",
  RDSMultiAZ: false,
  IsMultiZoneDeployment: false,
  DialogFlow: "disabled",
  DialogFlowClientToken: "",
  DialogFlowDevToken: "",
  // ChatGPT: "gpt-4",
  DeployServiceNowID: "True",
  DeployJiraID: "True",
  DeployEmailID: "False",
  DeployATRID: "True",
  InstanceType: "EventOps"
};

export const TuringFormModel = {
  ...commonFields,
  ...commonPlatformModel,
  // ConfigurationType: "full",
  AaamPlatformType: "myWizard AiOps Managed Platform",
  Tier: "",
  ProductInstanceUrl: null,
  CloudPlatform: "",
  MyClient: "",
  BaseOS: "",
  RDSMultiAZ: false,
  IsMultiZoneDeployment: false,
  DialogFlow: "disabled",
  DialogFlowClientToken: "",
  DialogFlowDevToken: "",
  ChatGPT: "aiops-deployment",
  OpenAiRegion: "",
  OpenAI: "True",
  SuperAdminDistributionGroup: "",
  OpenAITextEmbeddingsModel: "sentence-transformers/all-mpnet-base-v2"
  // EnableMultisource: false
};

export const StormSeerFormModel = {
  ...commonFields,
  ...commonPlatformModel,
  // ConfigurationType: "full",
  AaamPlatformType: "myWizard AiOps Stormseer Platform",
  Tier: "",
  ProductInstanceUrl: null,
  CloudPlatform: "",
  MyClient: "",
  BaseOS: "",
  RDSMultiAZ: false,
  IsMultiZoneDeployment: false,
  DialogFlow: "disabled",
  DialogFlowClientToken: "",
  DialogFlowDevToken: "",
};

export const ATRSaaSFormModel = {
  AAAMTermsConditions: "no",
  OrderUId: "",
  VendorName: "CAM",
  Status: "Placed",
  OrderItemUId: "",
  ProductUId: "07443833-aad2-4225-9683-9f8d8c11c3d7",
  DeploymentRegion: "sydney",
  ClientName: "",
  DomainContextRoot: "",
  WBSEcode: "",
  CustomerEnterpriseID: "",
  DryRun: "false",
  TeamsRelayEnabled: "false",
  TeamsClientId: "",
  TeamsClientSecret: "",
  TeamsBotName: "",
};

export const SplunkClusterFormModel = {
  ...commonFields,
  ...commonPlatformModel,
  ...bundleOrderModel,
  // ConfigurationType: "full",
  Tier: "",
  AaamPlatformType: "myWizard AiOps Splunk Cluster Platform",
  ProductInstanceUrl: null,
  CloudPlatform: "",
  MyClient: "",
  BaseOS: "",
  RDSMultiAZ: false,
  IsMultiZoneDeployment: false,
  HighAvailability: "no",
  StackApplication: [],
};

export const Stack360FormModel = {
  ...commonFields,
  ...commonPlatformModel,
  ...bundleOrderModel,
  ConfigurationType: "full",
  Tier: "",
  AaamPlatformType: "myWizard AiOps Stack Multitenant Platform",
  ProductInstanceUrl: null,
  CloudPlatform: "",
  MyClient: "",
  BaseOS: "",
  RDSMultiAZ: false,
  IsMultiZoneDeployment: false,
  //   HighAvailability: "no",
  OrderType: "New",
  StackApplication: ["acn-alertcentre360"],
};

export const StormWatchFormModel = {
  ...commonFields,
  ...commonAppModel,
};

export const AutomationJourneyFormModel = {
  ...commonFields,
  ...commonAppModel,
};

export const AutomationPlannerFormModel = {
  ...commonFields,
  ...commonAppModel,
};

export const IntelligentOpportunityMinerFormModel = {
  ...commonFields,
  ...commonAppModel,
};

export const GuidedTicketResolverFormModel = {
  ...commonFields,
  ...commonAppModel,
};

export const KlewerFormModel = {
  ...commonFields,
  ...commonAppModel,
};

export const QuasarFormModel = {
  ...commonFields,
  ...commonAppModel,
};

export const VirtualDataScientistFormModel = {
  ...commonFields,
  ...commonAppModel,
};

export const DPFormModel = {
  ...commonFields,
  ...commonPlatformModel,
  ...bundleOrderModel,
  // ConfigurationType: "full",
  Tier: "",
  AaamPlatformType: "myWizard AiOps Dedicated Platform",
  ProductInstanceUrl: null,
  CloudPlatform: "",
  MyClient: "",
  BaseOS: "",
  RDSMultiAZ: false,
  IsMultiZoneDeployment: false,
};

export const GWLFormModel = {
  ...commonFields,
  ...commonPlatformModel,
  ...bundleOrderModel,
  // ConfigurationType: "full",
  Tier: "",
  AaamPlatformType: "GenWizard AD Platform",
  ProductInstanceUrl: null,
  CloudPlatform: "",
  MyClient: "",
  BaseOS: "",
  RDSMultiAZ: false,
  IsMultiZoneDeployment: false,
  AppsIntegration: ["Quasarpp"],
  DBType: "",
  OpenAI: "True",
  ChatGPT: "aiops-deployment",
  OpenAITextEmbeddingsModel: "sentence-transformers/all-mpnet-base-v2",
  SuperAdminDistributionGroup: "",
  QppVersion: ""
};

export const ADFormModel = {
  ...commonFields,
  ...commonPlatformModel,
  ...bundleOrderModel,
  // ConfigurationType: "full",
  Tier: "gold",
  AaamPlatformType: "myWizard AiOps AD Platform",
  ProductInstanceUrl: null,
  CloudPlatform: "",
  MyClient: "",
  BaseOS: "",
  RDSMultiAZ: false,
  IsMultiZoneDeployment: false,
  DBType: "",
};

export const WPFormModel = {
  ...commonFields,
  ...commonPlatformModel,
  ...bundleOrderModel,
  // ConfigurationType: "full",
  Tier: "",
  AaamPlatformType: "myWizard AiOps Dedicated Platform",
  ProductInstanceUrl: null,
  CloudPlatform: "",
  MyClient: "",
  BaseOS: "",
  RDSMultiAZ: false,
  IsMultiZoneDeployment: false,
};


export const MPFormModel = {
  ...commonFields,
  ...commonPlatformModel,
  ...bundleOrderModel,
  AaamPlatformType: "myWizard AiOps Managed Platform",
  ProductInstanceUrl: null,
};
export const PIFormModel = {
  ...commonFields,
  ...commonPlatformModel,
  // ConfigurationType: "full",
  AaamPlatformType: "Plain Instance",
};

export const PAMFormModel = {
  ...commonFields,
  ...commonPlatformModel,
  // ConfigurationType: "full",
  AaamPlatformType: "PAM",
  EnableLandingPage: "",
  NewOrder: "true",
  PAMPlatformType: "",
};
export const GAFormModel = {
  ...commonFields,
  ...commonPlatformModel,
  // ConfigurationType: "full",
  AaamPlatformType: "GenWizard AiOps Genwizard Agent",
  Tier: "",
  ProductInstanceUrl: null,
  CloudPlatform: "",
  MyClient: "",
  BaseOS: "",
  RDSMultiAZ: false,
  IsMultiZoneDeployment: false,
  DialogFlow: "disabled",
  DialogFlowClientToken: "",
  DialogFlowDevToken: "",
  ChatGPT: "gpt-5.1-GS",
  ChatGPTCCAAS: "",
  OpenAiRegion: "",
  OpenAI: "True",
  SuperAdminDistributionGroup: "",
  OpenAITextEmbeddingsModel: "sentence-transformers/all-mpnet-base-v2",
  InstanceType: "Container",
  Genwizard_Agent_Module: [],
  Genwizard_Core: [],
  Genwizard_Agent_Tool: [],
  Genwizard_Tool: {},
  Genwizard_Steward_Option: '',
  modelname: '',
  ClaudeModel: 'claude-sonnet-4-5',
  CCAASConfig: {
      S3Bucket: '',
      S3AccessId: '',
      S3AccessKey:'',
      GCPEndPoint: '',
      GCPAccessKey:'',
      SMTPUsername:'',
      SMTPPassword: '',
      SMTPHostname:'',
      SMTPPort:'',
      SMTPSender:''
  },
  SAPAgentLLM : "AZURE",
  SAPAgentLLMConfig :{
      "Provider": "azure",
      "ClaudeModel": "claude-sonnet-4-5"
  }
};

export const UTKMFormModel = {
  ...commonFields,
  ...commonPlatformModel,
  // ConfigurationType: "full",
  AaamPlatformType: "myWizard AiOps UTKM Platform",
  Tier: "platinum",
  ProductInstanceUrl: null,
  CloudPlatform: "",
  MyClient: "",
  BaseOS: "",
  RDSMultiAZ: false,
  IsMultiZoneDeployment: false,
  DialogFlow: "disabled",
  DialogFlowClientToken: "",
  DialogFlowDevToken: "",
  ChatGPT: "aiops-deployment",
  KMApps: "",
  OpenAITextEmbeddingsModel: "sentence-transformers/all-mpnet-base-v2",
  SuperAdminDistributionGroup: "",
  Quasarpp: "dedicated"
};

export const KQFormModel = {
  ...commonFields,
  ...commonPlatformModel,
  // ConfigurationType: "full",
  AaamPlatformType: "PAM",
  EnableLandingPage: "",
  NewOrder: "true",
  ChatGPT: "aiops-deployment",
  PAMPlatformType: "",
};
export const AALFormModel = {
  ...commonFields,
  InstanceType: "",
  ChooseNewOrExistingInstance: "",
  ChooseTheExistingInstance: "Automation Anywhere Licenses Instance",
  InstanceName: "Automation Anywhere Licenses Instance",
  InstanceUrl: "None",
  DeploymentRegion: "singapore",
  AAversion: "",
  DomainContextRoot: "",
  LicenseUsage: "",
  NumOfControlRoomlicenses: "",
  NumOfRunnerlicenses: "",
  NumOfDeveloperlicenses: "",
  RequestNotes: "",
  ProductInstanceUId: "Automation Anywhere Licenses Instance",
  ProductInstanceName: "Automation Anywhere Licenses Instance",
  ProductInstanceUrl: null,
  VendorName: "CAM",
  ConfigurationType: "full",
};

export const OPSFormModel = {
  ...commonFields,
  VendorName: "CAM",
  DeploymentRegion: "",
  GeographicArea: "",
  BenefitsExpected: "",
  Environment: "",
  TentativeServiceEndDate: moment()
    .add(1, "days")
    .format("YYYY-MM-DD"),
  DailyDataVolume: "",
  Custom: "",
  ServiceGroup: "",
  AaamPlatformType: "myWizard AiOps On-Premise Service",
  SplitDataVolume: [],
  InfrastructureType: "",
  LicensePurpose: "",
  RequestNotes: "",
  AiOpsAsset: [],
};

export const appUrlModel = {
  OrderUId: "",
  ClientName: "",
  OrderItems: [
    {
      OrderItemUId: "",
      CreatedBy: "",
      CreatedDate: "",
      CreateDate: "",
      Status: "Placed",
      ProductUId: "17cf154b-9c35-43a0-9902-55b247ebda57",
      VendorName: "CAM",
      Notes: "",
      AccessLinkURL: "",
      Config: [],
    },
  ],
};
export const SIFormModel = {
  ...commonFields,
  ...commonPlatformModel,
  // ConfigurationType: "full",
  Tier: "",
  AaamPlatformType: "Genwizard AiOps Service Integrator",
  ProductInstanceUrl: null,
  CloudPlatform: "",
  MyClient: "",
  BaseOS: "Alma",
  RDSMultiAZ: false,
  IsMultiZoneDeployment: false,
  InstanceId: "",
};

export const ECCFormModel = {
  ...commonFields,
  ...commonPlatformModel,
  // ConfigurationType: "full",
  Tier: "",
  AaamPlatformType: "Claude Instance",
  ProductInstanceUrl: null,
  CloudPlatform: "",
  MyClient: "",
  BaseOS: "Alma",
  RDSMultiAZ: false,
  IsMultiZoneDeployment: false,
};

export const AMFormModel = {
  ...commonFields,
  ...commonPlatformModel,
  // ConfigurationType: "full",
  Tier: "",
  AaamPlatformType: "Agent Mesh",
  ProductInstanceUrl: null,
  CloudPlatform: "",
  MyClient: "",
  BaseOS: "Alma",
  RDSMultiAZ: false,
  IsMultiZoneDeployment: false,
  OpenAI: "True",
  ChatGPT: "aiops-deployment",
  Company: "",
  AvanadeCountry: "",
  AccentureCountry: ""
};
export const CIAFormModel = {
  ...commonFields,
  ...commonPlatformModel,
  // ConfigurationType: "full",
  Tier: "",
  AaamPlatformType: "CIA",
  ProductInstanceUrl: null,
  CloudPlatform: "",
  MyClient: "",
  BaseOS: "Alma",
  RDSMultiAZ: false,
  IsMultiZoneDeployment: false,
  OpenAI: "True",
  ChatGPT: "aiops-deployment",
  Company: "",
  AvanadeCountry: "",
  AccentureCountry: ""
};

export const CPFormModel = {
  ...commonFields,
  ...commonPlatformModel,
  // ConfigurationType: "full",
  Tier: "",
  AaamPlatformType: "CIA",
  ProductInstanceUrl: null,
  CloudPlatform: "",
  MyClient: "",
  BaseOS: "Alma",
  RDSMultiAZ: false,
  IsMultiZoneDeployment: false,
  OpenAI: "True",
  ChatGPT: "aiops-deployment",
  Company: "",
  AvanadeCountry: "",
  AccentureCountry: "",
  InstanceType: "Dedicated",
};
export const BRFormModel = {
  DeploymentRegion: "",
  modelname: "",
  Environment: "",
  CustomerEnterpriseID: "",
  WBSEcode: "",
  ClientName: "",
  RequestNotes: "",
};
export const REFormModel = {
  ...commonFields,
  ...commonPlatformModel,
  // ConfigurationType: "full",
  AaamPlatformType: "GenWizard AiOps Genwizard Agent",
  Tier: "",
  ProductInstanceUrl: null,
  CloudPlatform: "",
  MyClient: "",
  BaseOS: "",
  RDSMultiAZ: false,
  IsMultiZoneDeployment: false,
  DialogFlow: "disabled",
  DialogFlowClientToken: "",
  DialogFlowDevToken: "",
  ChatGPT: "gpt-5.1-GS",
  OpenAiRegion: "",
  OpenAI: "True",
  SuperAdminDistributionGroup: "",
  OpenAITextEmbeddingsModel: "sentence-transformers/all-mpnet-base-v2",
  InstanceType: "Container",
  CuiIntegration: false,
  UsedExistingCui: "No",
  CuiEndPoint: "",
  CuiPasskey: "",
  OpenAIServiceName:"",
  UsedExistingOpenAI: false
};